module.exports = __webpack_public_path__ + "media/assets/images/flags/mn-6ba7a1d4dbc3cc6d144fe728c69dedcf.svg";